import { Button, Divider, Tooltip, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "recompose";
import {
  clearDrawerNavigation,
  selectDrawerNavigationOption,
  setDrawerNavigationMode,
} from "../../../../actions/drawerNavigationActions";
import { getMyDrawerFromPath } from "../../../../utils/drawerNavigation/myDrawerNavigationHelpers";
import DrawerContainer from "../../../components/App/Drawers/SearchLeftDrawer/DrawerContainer";
import { useDrawerNavigation } from "../../../components/Common/Hooks/useDrawerNavigation/useDrawerNavigation";
import withErrorCatcher from "../../../components/Common/withErrorCatcher";
import { TagsInfoDrawer } from "../../../components/TagsInfo/TagsInfoDrawer";
import { DrawerSwitcherNew } from "./DrawerSwitcher";
import goTo from "../../../actions/goTo";
import { createTagPayload } from "../../../../utils/tagHelpers";
import {themeConstants} from '../../../../theme';
import { useGetTagAdditionalOptions } from '../../../components/Common/Hooks/useDrawerNavigation/useGetTagAdditionalOptions';
import { withMixpanel } from '../../../components/Common/withMixpanel';
import SubscribeIcon from "../../../components/Common/Icons/UserIcons/SubscribeIcon";
import UnsubscribeIcon from "../../../components/Common/Icons/UserIcons/UnsubscribeIcon";
import EditTagIcon from '../../../components/Common/Icons/UserIcons/EditTagIcon';
import { createCustomTheme } from "../../../../utils/theming";
import { hexToRGB } from "../../../../utils/hexToRGB";

const styles = (theme) => {
  const primaryColor = theme.customColors.primary.b300
  const lighterColor = hexToRGB(primaryColor, 0.1)
  const primaryColor09Opacity = hexToRGB(primaryColor, 0.999)
  return ({
    container: {
      paddingTop: 24,
  },
  divider: {
    backgroundColor: "#daddee",
  },
  navigation: {
    margin: 16,
  },
  navigationSmall: {
    margin: 16,
  },
  drawerWrapper: {
        position: 'relative',
  },
  paper: {
    height: 'inherit!important',
    width: themeConstants.navigationDrawerWidth,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        display: 'none'
    },
  },
  drawerButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 24,
    marginTop: 24,
  },
    settingsButton: {
       cursor: 'pointer',
        height: 28,
        width: 83,
        marginLeft: 10,
        border: `1px solid ${theme.customColors.primary.b500}`,
        textTransform: 'none',
        fontFamily: 'Rubik',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 400,
        color: theme.customColors.primary.b500,
        borderRadius: 4,
        "&:hover": {
          backgroundColor:  lighterColor,
      },
    },
    settingsButtonColored: {
      cursor: 'pointer',
      height: 28,
      width: 83,
      textTransform: 'none',
      fontFamily: 'Rubik',
      fontSize: 12,
      fontStyle: 'normal',
      fontWeight: 400,
      color: 'white',
      backgroundColor: theme.customColors.primary.b500,
      borderRadius: 4,
      "&:hover": {
        backgroundColor: primaryColor09Opacity,
    },
  },
  drawerSmallButtons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 22,
    marginBottom: 24,
  },
 
  smallButtonIcon: {
    width: 30,
    height: 28,
    border: `1px solid ${theme.customColors.primary.b500}`,
    textAlign: 'center',
    marginRight: 8,
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 4,
    marginTop: 8,
    "&:hover": {
        backgroundColor:  lighterColor,
    },
  },
  smallColoredButtonIcon: {
    width: 32,
    height: 28,
    textAlign: 'center',
    marginRight: 8,
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 4,
    backgroundColor: theme.customColors.primary.b500,
    "&:hover": {
        backgroundColor: primaryColor09Opacity,
    },
},
  tooltip: {
    fontSize: 12,
    backgroundColor: '#4A4A4F',
    padding: '4px 8px',
    borderRadius: 4,
    fontfamily: 'Rubik',
    lineHeight: '16px',
},
triangle: {
    position: 'absolute',
    top: '50%',
    left: -3,
    marginTop: -3.5,
    transform: 'rotate(-45deg)',
    border: `solid 3px #4A4A4F`,
    borderRight: `3px solid transparent`,
    borderBottom: `3px solid transparent`,
    zIndex: '9999'
},
})};

const __TagPageLeftDrawerNew = (props) => {
  const { 
    query, 
    classes, 
    dispatch, 
    drawerNavigation, 
    userData, 
    tagInfo, 
    relatedTagsQuery, 
    mixpanelTrack, 
    subscribedChannels,
    userSettingsService,
    profileData,
   } = props;
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [topicsTags, setTopicsTags] = useState([]);
  const [currentTagInfo, setCurrentTagInfo] = useState(tagInfo);
  const [t] = useTranslation("groupDrawerTranslate");
  const paperStyle = isDrawerOpen ? {} : { width: themeConstants.navigationDrawerSmallWidth, overflowX: 'hidden' };
  const isTopic = currentTagInfo?.tagType?.toLowerCase() === 'topic'

  const themeOption = profileData.org?.brandingColor ?? 'default'
  const theme = createCustomTheme(themeOption)

  useEffect(() => {
    const { pathname } = window.location;
    const [mode, id] = getMyDrawerFromPath(pathname);

    dispatch(setDrawerNavigationMode(mode));
    dispatch(selectDrawerNavigationOption(id));

    return () => {
      dispatch(clearDrawerNavigation());
    };
  }, []);

  useEffect(() => {
    const ti = tagInfo.failed ? createTagPayload(query.slice(1), null, 'user_tag', 'MISC') : tagInfo
    setCurrentTagInfo(ti)
  }, [tagInfo, query])

  useEffect(() => {
    if(currentTagInfo?.tagType === 'topic') {
      setTopicsTags(currentTagInfo?.topicTags?.map(t => ({key: t})) ?? [])
      return
    }
    setTopicsTags([])
  }, [currentTagInfo])

  const selectChannelHandler = (channel) => {
    mixpanelTrack(`Channel page view - ${channel}`, {})
    goTo("#" + channel, dispatch)();
  };

  const [additionalOptions, EditTag] = useGetTagAdditionalOptions({
    t,
    query,
    isTopic,
    currentTagInfo,
    userData,
    dispatch,
    subscribedChannels,
    userSettingsService,
  })

  const [Navigation] = useDrawerNavigation({
    drawerNavigation,
    isChannel: true,
    currentTags: isTopic ? topicsTags : relatedTagsQuery,
    isDrawerOpen,
    profileData,
    query,
    selectChannelHandler,
    // additionalOptions: [],
    t
  });

  const NavigationSection = (
    <div data-intrcm-id="TagPageLeftDrawerNew_jocetm9f"
      className={isDrawerOpen ? classes.navigation : classes.navigationSmall}
    >
      {Navigation}
    </div>
  );

  const handleSwitchDrawerStatus = (status) => {
    setIsDrawerOpen(status);
  };

  return (
    <div data-intrcm-id="TagPageLeftDrawerNew_p3lk45vk" className={classes.drawerWrapper}>
      <DrawerContainer containerStyle={`${classes.container} ${classes.paper}`} PaperProps={{ style: paperStyle }} open={isDrawerOpen}>
      <DrawerSwitcherNew isDrawerOpen={isDrawerOpen} onClick={handleSwitchDrawerStatus}/>
        <TagsInfoDrawer currentTagInfo={currentTagInfo} query={query} isDrawerOpen={isDrawerOpen}/>
          { isDrawerOpen ? <div data-intrcm-id="TagPageLeftDrawerNew_l33kj4tq" className={classes.drawerButtons}>
          {additionalOptions.map(el => {
            return (
              <Button onClick={el.onClick} className={el.title === "Edit" ? classes.settingsButtonColored  :  classes.settingsButton} >
                {el.title}
              </Button> 
            )
            })}
          </div> : <div data-intrcm-id="TagPageLeftDrawerNew_h1jqijb5" className={classes.drawerSmallButtons}> 
              {additionalOptions.map(el => (
                  <Tooltip
                            placement="right" 
                            title={<>
                              {el.title}
                              <div data-intrcm-id="TagPageLeftDrawerNew_4jcpjcok" className={classes.triangle}></div>
                          </> }
                            disableHoverListener={false} 
                            classes={{tooltip: classes.tooltip}}
                            onClick={el.onClick}
                            >
                            <div data-intrcm-id="TagPageLeftDrawerNew_iher7vn9" className={ el.title === "Edit"  ? classes.smallColoredButtonIcon : classes.smallButtonIcon}>
                              {el.title === "Edit" && <EditTagIcon color={theme.primary.b500} /> }
                              {el.title === "Subscribe" && <SubscribeIcon color={theme.primary.b500} /> }
                              {el.title === "Unsubscribe" && <UnsubscribeIcon color={theme.primary.b500} /> }
                              </div>
                      </Tooltip>
                ))}
            </div>
            }
        <Divider className={classes.divider} />
        {NavigationSection}
      </DrawerContainer>
        {EditTag}
    </div>
  );
};

const mapStateToProps = (state) => ({
  tagInfo: state.results.channel,
  profileData: state.userData.profileData,
  drawerNavigation: state.drawerNavigation,
  relatedTagsQuery: state.results.relatedTagsQuery,
  userData: state.userData,
  userSettingsService: state.services.userSettingsService,
  subscribedChannels: state.userData.subscribedTags,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export const TagPageLeftDrawerNew = compose(
  withStyles(styles),
  withTranslation('widgetLibrary'),
  withErrorCatcher("Failed loading User Info, Please Contact Tuqqi Support"),
  withMixpanel,
  connect(mapStateToProps, mapDispatchToProps)
)(__TagPageLeftDrawerNew);
